import React, { useEffect, useState } from "react";
import PageTitle from "../../../module/pageTitle";
import AdminTable from "../../../Component/adminTable";
import LabelInput from "../../../Component/labelInput";
import { InputField, Submitbtn } from "../../../Component";
import DropDown from "../../../Component/dropdown";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import {
  getDepartmentList,
  getSubDepartmentList,
  updateSubDepartment,
  deleteSubDepartment,
} from "../superAdminSlice";
import { showSnackbar, hideSnackbar } from '../../../store/slices/snackbarSlice';
const EditDeleteSubDepartment = () => {
  const dispatch: Function = useDispatch<AppDispatch>();
  const [isEdit, setIsEdit] = useState<Boolean>(false);
  const [departmentList, setDepartmentList] = useState<any>([]);
  const [department, setDepartment] = useState<any>("");
  const [subDepartmentList, setSubDepartmentList] = useState<any>([]);
  const [subDepartment, setSubDepartment] = useState<any>("");
  const [subDepartmentID, setSubDepartmentID] = useState<any>("");
  useEffect(() => {
    dispatch(
      getDepartmentList({
        callback: (res: any) => {
          setDepartmentList(res?.data);
          dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
          setTimeout(() => {
            dispatch(hideSnackbar());
          }, 5000);
        },
        errorCallback: () => {
          dispatch(showSnackbar({ message: "Something went wrong", type: "error" }));
          setTimeout(() => {
            dispatch(hideSnackbar());
          }, 5000);
        },
      })
    );
  }, []);

  const handleEdit = (value: any) => {
    setIsEdit(true);
    setSubDepartment(value?.name);
    setSubDepartmentID(value?._id);
  };

  const onChangeDepartment = (val: any) => {
    setDepartment(val);
    dispatch(
      getSubDepartmentList({
        id: val?._id,
        callback: (res: any) => {
          setSubDepartmentList(res?.data);
        },
        errorCallback: () => { },
      })
    );
  };
  const onChangeSubDepartment = (value: string) => {
    setSubDepartment(value);
  };

  const handleSubmit = (e: { preventDefault: () => void }) => {
    setIsEdit(true);
    e.preventDefault();
    const Payload = {
      name: subDepartment,
    };
    dispatch(
      updateSubDepartment({
        id: subDepartmentID,
        params: Payload,
        callback: (res: any) => {
          setIsEdit(false);
          dispatch(
            getSubDepartmentList({
              id: department?._id,
              callback: (res: any) => {
                setSubDepartmentList(res?.data);
                dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
                setTimeout(() => {
                  dispatch(hideSnackbar());
                }, 5000);
              },
              errorCallback: () => { },
            })
          );
        },
        errorCallback: () => { },
      })
    );
  };
  const handleDelete = (value: any) => {
    dispatch(
      deleteSubDepartment({
        id: value?._id,
        callback: (res: any) => {
          setIsEdit(false);
          dispatch(
            getSubDepartmentList({
              id: department?._id,
              callback: (res: any) => {
                setSubDepartmentList(res?.data);
                dispatch(showSnackbar({ message: res?.msg, type: res?.status }));
                setTimeout(() => {
                  dispatch(hideSnackbar());
                }, 5000);
              },
              errorCallback: () => {
                dispatch(showSnackbar({ message: "Something went wrong", type: "error" }));
                setTimeout(() => {
                  dispatch(hideSnackbar());
                }, 5000);
              },
            })
          );
        },
        errorCallback: () => { },
      })
    );
  };
  const renderTable = () => {
    return (
      <AdminTable
        tableData={subDepartmentList ? subDepartmentList : []}
        pagename={"SubDepartmentList"}
        tableHead={["S.N", "Department", "SubDepartemt", "Action"]}
        handleEdit={(value: any) => handleEdit(value)}
        handleDelete={(value: any) => handleDelete(value)}
        edit={true}
      />
    );
  };
  const renderSearch = () => {
    return (
      <>
        <form className="mb-4">
          <div className="row align-items-center">
            <div className="col-md-4">
              <LabelInput labelName={"Select Department"} />
              <DropDown
                labelName="Select Department Name"
                setInputText={(value: any) => onChangeDepartment(value)}
                options={departmentList}
                value={department}
                disabled={isEdit}
              />
            </div>
          </div>
        </form>
        {isEdit ? renderEditMode() : ""}
      </>
    );
  };
  const renderEditMode = () => {
    return (
      <form onSubmit={handleSubmit}>
        <div className="row align-items-center">
          <div className="col-md-4">
            <LabelInput labelName={"Sub Department"} />
            <InputField
              key={"ex2"}
              placeholder={"Enter Sub Department Name"}
              setInputText={(value: any) => onChangeSubDepartment(value)}
              value={subDepartment}
            />
          </div>
          <div className="col-md-2">
            <LabelInput labelName={""} />
            <Submitbtn name={"Edit"} disabled={!subDepartment} />
          </div>
        </div>
      </form>
    );
  };
  return (
    <div className="panel-content">
      <div className="mb-4">
        <PageTitle
          name={"Edit / Delete Sub DepartMent"}
          breadCrumb={""}
          isEditMode={""}
          cancelEdit={() => ""}
        />
      </div>
      <div className="formDiv">
        <div className="bxshadow p-2 borderRadius mb-4">{renderSearch()}</div>
        {!isEdit ? (
          <div className="bxshadow p-2 borderRadius">{renderTable()}</div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default EditDeleteSubDepartment;
